import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';

export default function SetGenesisPasswordForm({
	resetPasswordToken,
	handleSetGenesisPassword
}) {

	const [localState, setLocalState] = useState({
		inputGenesisPassword: "",
		repeatPassword: "",
		showLoader: false,
		showValidationError: false,
	})
	const [showLoader, setShowLoader] = useState(null)
	const [showValidationError, setShowValidationError] = useState(null)

	const { inputGenesisPassword, repeatPassword } = localState;

	const handleChange = (event) => {
		const value = event.target.value;
		setLocalState(prevState => ({
			...prevState,
			[event.target.name]: value
		}));

		!!showValidationError && setShowValidationError(false)
	}

	const submitSetNewPassword = () => {
		const sameInputs = ((inputGenesisPassword && inputGenesisPassword.length > 5) && (inputGenesisPassword === repeatPassword)) ? true : false;

		if (sameInputs) {
			setShowLoader(true)
			handleSetGenesisPassword({ useCase: "set-genesis-password", inputGenesisPassword, resetPasswordToken })
		}

		if (!sameInputs) {
			setShowValidationError(true)
		}
	}

	if (showLoader) {
		return (
			<PageLoader />
		)
	} else {
		return (
			<Flex direction='column' gap="0.5em" w="100%" align="center" maxW='20em' mt='1.5em'>

				<LaunchdeckFormInput
					label='Password'
					name={'inputGenesisPassword'}
					onChange={handleChange}
					value={inputGenesisPassword || ""}
					type='password'
				/>

				<LaunchdeckFormInput
					label='Confirm password'
					name={'repeatPassword'}
					onChange={handleChange}
					value={repeatPassword || ""}
					type='password'

					errorLogic={showValidationError}
					errorMessage="Your confirmation password did not match, or they aren't long enough"
				/>

				<Box mt='2em' w='100%'>
					<LaunchdeckButton bg='brand.500' color='white' w='100%' onClick={() => submitSetNewPassword()} label='Set Password' />
				</Box>

			</Flex>
		)
	}



};